"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../../actions/backgroundFilters/types");
var _VirtualBackground = require("@studio/constants/VirtualBackground");
/**
 * @param state The userBackground state, initial state should be NONE since userBackground is NONE by default
 * @param action The action being dispatched
 * @returns {*|boolean}
 */
function userBackground() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _VirtualBackground.BACKGROUND_OPTIONS.NONE;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === _types.SET_BACKGROUND_OPTION) {
    return action.payload.userBackground;
  }
  return state;
}
var _default = exports["default"] = userBackground;